import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAPI } from './useAPIs';
import {
  Autocomplete,
  TextField,
  CircularProgress,
  Box,
} from '@mui/material';

const UserAutocomplete = ({
  value,               
  onChange,            
  disabled = false,
  label = 'User',
  placeholder = 'Search user…',
  size = 'small',
}) => {
  const [inputValue, setInputValue] = useState('');
  const { apiCall } = useAPI();

  const { data = [], isFetching } = useQuery({
    queryKey: ['user-autocomplete', inputValue],
    queryFn: async () => {
      const resp = await apiCall('GET', `/api/v1/users/autocomplete/?q=${inputValue}`);
      return resp.data;               
    },
    enabled: inputValue.length > 0,
    keepPreviousData: true,
  });

  return (
    <Autocomplete
      fullWidth
      disabled={disabled}
      size={size}
      loading={isFetching}
      value={value}
      inputValue={inputValue}
      onInputChange={(_, newInput) => setInputValue(newInput)}
      onChange={(_, newVal) => onChange(newVal)}   
      options={data}
      getOptionLabel={(opt) =>
        opt?.display_name ? `${opt.display_name} (${opt.email})` : opt?.email ?? ''
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isFetching ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default UserAutocomplete;